import { render, staticRenderFns } from "./lib.vue?vue&type=template&id=5c7230f7&"
import script from "./lib.vue?vue&type=script&lang=js&"
export * from "./lib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports